import api from "api";
import { IGetCustomersQueryParams } from "types/customer";

const getCustomers = ({ sortBy, pageIndex, pageSize, search }: IGetCustomersQueryParams) => 
  api.get(`/customer/getCustomers?sortBy=${sortBy}&pageIndex=${pageIndex}&pageSize=${pageSize}&search=${search}`)

const blockUnblockCustomer = (customerId: string) =>
  api.post(`/customer/blockUnblockCustomer/${customerId}`)

const deleteCustomer = (customerId: string) =>
  api.delete(`/customer/deleteCustomer/${customerId}`)

const getCustomerVehicles = (customerId: string) =>
  api.get(`/customer/getCustomerVehicles/${customerId}`)

export default { getCustomers, blockUnblockCustomer, deleteCustomer, getCustomerVehicles }